import { useSelector } from 'react-redux';
import type { RefObject, VoidFunctionComponent } from 'react';
import Drawer from '../../../../generic/Drawer';
import DrawerHeader from './Header';
import DrawerDescription from './Description';
import DrawerDetails from './Details';
import DrawerRemediation from './Remediation';
import DrawerNVDBaseMetrics from './NVDBaseMetrics';
import DrawerReferences from './References';
import * as PackageInventoryStore from '../../../../../redux/packageInventory';
import { ErrorAlert } from '../../../../generic';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  //  Current version is displayed in the remediation section
  version: string;
  //  Needed to prevent the Drawer from closing when we click a different item in the table.
  tableBodyRef: RefObject<HTMLTableSectionElement>;
  //  Duration of the slide animation.
  slideDuration: number;
 // The locator of the package revision that the drawer is displaying.
  packageRevisionLocator: string;
};

/**
 * PackgeVersionVulnerabilityDrawer displays the selectedVuln.
 */
const PackgeVersionVulnerabilityDrawer: VoidFunctionComponent<Props> = ({
  isOpen,
  onClose,
  version,
  tableBodyRef,
  slideDuration,
  packageRevisionLocator,
}) => {
  const status = useSelector(PackageInventoryStore.selectors.getAsyncStatusGetSelectedVuln);
  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      clickTarget={tableBodyRef}
      slideDuration={slideDuration}
    >
      {status.errors?.length ? (
        <div className="margin-top-lg">
          <ErrorAlert status={status} />
        </div>
      ) : (
        <>
          <DrawerHeader />
          <DrawerRemediation version={version} packageRevisionLocator={packageRevisionLocator} />
          <DrawerDetails />
          <DrawerDescription />
          <DrawerNVDBaseMetrics />
          <DrawerReferences />
        </>
      )}
    </Drawer>
  );
};

export default PackgeVersionVulnerabilityDrawer;
